export enum LayerCode {
  verkaufsobjekte = 'verkaufsobjekte',
  parzellen = 'parzellen',
  grundstueck_architektonische = 'M_grundstueck_architektonische',
  av_webgis_sw_liegenschaften = 'av_webgis_sw_liegenschaften',
  p_verkaufsobjekte = 'p_verkaufsobjekte',
  strategieflaeche = 'strategieflaeche',
  sap = 'sap',
  parzellen_view = 'parzellen_view',
  areale_view = 'areale_view',
  nutzflaeche_infra = 'nutzflaeche_infra',
  denkmalpflege = 'denkmalpflege',
  isos = 'isos',
  gebaeude = 'gebaeude',
  liegenschaft_grundstuecke = 'liegenschaft_grundstuecke',
  liegenschaften_selbststaendige_rechte = 'liegenschaften_selbststaendige_rechte',
  map_parzelle = 'map_parzelle',
  av_webgis_sw_liegenschaftenNr = 'av_webgis_sw_liegenschaftenNr',
  map_Hektometer = 'map_Hektometer',
  map_Kilometrierung = 'map_Kilometrierung',
  energie_mbul = 'energie_mbul',
  dgp_leitungskataster = 'dgp_leitungskataster',
  dgp_leitungendritter = 'dgp_leitungendritter',
  stoerfallpunkte = 'stoerfallpunkte',
  altlasten = 'altlasten',
  gs_gewaesser = 'gs_gewaesser',
  mbul_bauvorhaben = 'mbul_bauvorhaben',
  streckennetz = 'streckennetz',
  av_webgis_sw_vector_tile = 'av_webgis_sw_vector_tile',
  av_webgis_ausland = 'av_webgis_ausland',
  dgp_bahnplan = 'dgp_bahnplan',
  dgp_ingenieurbau = 'dgp_ingenieurbau',
  bahnhof_und_ausruestung = 'bahnhof_und_ausruestung',
  energie = 'energie',
  grenzen = 'grenzen',
  geo_admin_zonenplan_harmonisiert = 'geo_admin_zonenplan_harmonisiert',
  wms_kabelleitungen_swisscom = 'wms_kabelleitungen_swisscom',
  lineinfo = 'lineinfo',

  // FeatureLayers
  f_liegenschaften_proj_grundstuecke = 'f_liegenschaften_proj_grundstuecke',
  f_liegenschaften_proj_selbst_rechte = 'f_liegenschaften_proj_selbst_rechte',
  f_gebaeude = 'av_gebaeude',
  f_isba_eo_report = 'f_isba_eo_report',
  f_isba_ko_report = 'f_isba_ko_report',
  f_public_strategieflaeche = 'strategieflaechen',
  f_verkaufsobjekte = 'transaktionsobjekt',
  f_public_verkaufsobjekte = 'f_public_verkaufsobjekte',
  f_parzellen = 'grundstueck',
  f_teilparzelle = 'teilgrundstueck',
  f_parzelleDritt = 'grundstueckdritt',

  f_grundstueck_architektonische = 'grundstueck_architektonische',
  f_teilgrundstueck_architektonisches = 'teilgrundstueck_architektonisches',


  f_liegenschaft_grundstuecke = 'f_liegenschaft_grundstuecke',
  f_liegenschaften_selbststaendige_rechte = 'f_liegenschaften_selbststaendige_rechte',
  f_betriebspunkt = 'f_betriebspunkt',
  f_public_refx_gb = 'f_public_refx_gb',
  f_public_refx_gr = 'f_public_refx_gr',
  f_public_trasse = 'f_public_trasse',
  f_public_altlasten_standort = 'f_public_altlasten_standort',
  f_public_sap_mietertraege = 'f_public_sap_mietertraege',
  f_public_nutzflaeche = 'nutzflaeche',
  f_public_areale = 'f_public_areale',
  f_public_abschnitt = 'f_public_abschnitt',
  f_public_mast = 'f_public_mast',
  f_parzelle_Locate_view = 'f_parzelle_Locate_view',
  f_teilparzelle_Locate_view = 'f_teilparzelle_Locate_view'
}
